import React, { useEffect } from 'react'
import { History, Location } from 'history'
import { Table, Button, Divider, Popconfirm, notification } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { Link, generatePath } from 'react-router-dom'
import CopyToClipboard from 'react-copy-to-clipboard'
import _ from 'lodash'

import { Page } from '../../components/Page'
import { Layout } from '../../components/Page/Layout'
import { ADD_THEME, THEME_DETAIL } from '../../routes'
import { ThemeActions } from '../../features/theme/actions'
import { getThemes } from '../../features/theme/selectors'
import { Theme } from '../../features/theme/types'
import { Title } from '../../components/Text'

type Props = {
  history: History
  location: Location<{ showInDashboard?: boolean } | undefined>
}

export const ThemesContainer = ({ history }: Props) => {
  const dispatch = useDispatch()
  const themes = useSelector(getThemes)

  useEffect(() => {
    dispatch(ThemeActions.fetchThemes())
  }, [dispatch])

  const editTheme = (h: Theme) => {
    history.push(generatePath(THEME_DETAIL, { themeId: h.id }))
  }

  const dataSource = _.map(themes, (theme: Theme) => {
    return {
      id: theme.id,
      key: theme.id,
      name: theme.name,
      logo: theme.logo
    }
  })

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name'
    },
    {
      title: 'Logo',
      dataIndex: 'logo',
      key: 'logo',
      // eslint-disable-next-line react/display-name
      render: (name: string) => (
        <span>
          <img src={name} alt="test" width={90} />
        </span>
      )
    },
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      // eslint-disable-next-line react/display-name
      render: (text: string) => (
        <div>
          {text}
          <Divider type="vertical" />
          <CopyToClipboard
            text={text}
            onCopy={() => {
              notification.success({
                description: text,
                message: 'ID copiato'
              })
            }}
          >
            <Button type="ghost">COPY</Button>
          </CopyToClipboard>
        </div>
      )
    },
    {
      title: 'Action',
      key: 'action',
      // eslint-disable-next-line react/display-name
      render: (_text: string, record: Theme) => (
        <span>
          <Button type="link" onClick={() => editTheme(record)}>
            Edit
          </Button>
          <Divider type="vertical" />
          <Popconfirm
            title="Sei sicuro di voler eliminare questo Theme?"
            onConfirm={() => dispatch(ThemeActions.startDeletingTheme(record.id))}
            onCancel={() => _.noop()}
            okText="Yes"
            cancelText="No"
          >
            <Button type="link">Delete</Button>
          </Popconfirm>
        </span>
      )
    }
  ]

  return (
    <Page>
      <Layout>
        <Title size="XL">Themes</Title>
        <Table dataSource={dataSource} columns={columns} />
        <div>
          <Link to={ADD_THEME}>
            <Button>Nuovo</Button>
          </Link>
        </div>
      </Layout>
    </Page>
  )
}
